import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';
import { TosterMsgType } from 'src/app/services/model';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';

@Component({
  selector: 'app-pan-details',
  templateUrl: './pan-details.component.html',
  styleUrls: ['./pan-details.component.scss']
})
export class PanDetailsComponent implements OnInit{

  panNumber: string = '';
  input:any;
  errorMsg:string='';
  defaultLength:number = ConstantData.panCardLength;
  loandetails:any;
  isValidPan: Boolean = false;
  @Output() isValidStatus = new EventEmitter();
  showLoader:boolean=false;


  get panLenth(){
    return this.formGroup.get('panNumber')?.value.length;
  }

  constructor(private util: UtilService,) {}
  ngOnInit(): void {
    this.util.setCache('panData', null);
    this.loandetails = this.util.loanDetails;
    this.panNumber = this.util.getCurrentApplicant.panInfo?.pan;
    this.util.setCache('kycTab' , 'basic');
    
  }

  formGroup: FormGroup = new FormGroup({
    'panNumber':new FormControl('', [Validators.required,]),
  });

  onPanNumberInput(event: any) {
    const loanData = this.util.loanDetails;
    // this.isValidPan = false;
    this.isValidStatus.emit(false);
    this.errorMsg = '';
    this.input = event.target.value;
    let panNumberInput = event.target.value.replace(/[^A-Za-z0-9]/g, '');
    panNumberInput = panNumberInput.toUpperCase();
    this.formGroup.controls['panNumber'].setValue(panNumberInput); 
   
    if(this.formGroup.valid){
      this.showLoader = true;
      this.util.cleverTapEventCall(CleverTapConstents.pan_verifi_init,{
        'applicantType': this.util.getCurrentApplicant?.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory, 
      });
      this.util.handleRequests('put',this.util.getUrl('pan_validation',[this.util.loanDetails.loanId,this.formGroup.controls['panNumber'].value,this.util.getCurrentApplicant.id]),undefined,undefined,undefined,undefined,false).
      then((res:any)=>{

        // auto nevigation 
          if(loanData.isStudentMainApplicant && !loanData.isSponser && this.util.getCurrentApplicant.mainApplicant){
            //if student is main applicant
            if(res.content.vendorResponse.panStatus == 'VALID')
            this.isValidPan = true;

            this.panConfirmation(res.content?.vendorResponse?.result?.result);
          }else{
            if(res.content.vendorResponse.panStatus == 'VALID')
            this.isValidPan = true;
            this.util.cleverTapEventCall(CleverTapConstents.pan_verifi_suc,{
          'status': 'Successful',
          'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
            });
          this.util.getLoandetails(false).then(() => {
          });
          this.util.setCache('panNumber',this.formGroup.controls['panNumber'].value);
          this.util.setCache('panData', res.content?.vendorResponse?.result?.result || {});
          this.isValidStatus.emit(true);
          }
          this.showLoader = false;
      })
      .catch(err=>{
        this.showMismatchError(err.data.content);
        const res = JSON.parse(err.error)
        this.errorMsg= res.content.message;
        this.showLoader = false;
        this.util.cleverTapEventCall(CleverTapConstents.pan_verifi_fail,{
          'status': 'Failure',
      'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
        });
      })
    }
  }
  panConfirmation(content:any){
    this.util.handleRequests('put',this.util.getUrl('loan_pan',[
      this.util.loanDetails.loanId,this.util.getCurrentApplicant.id]),{
        'pan': this.formGroup.controls['panNumber'].value,
      }).
    then(res=>{
     this.util.getProducts().then(()=>{
      this.util.navigationHandler();
     });
  }).catch((err:any)=>{
    this.showMismatchError(err.data.content, content);
  })
  }

  showMismatchError(error:any, panData?:any){
    const misMatchStatus = ConstantData.misMatchStatus;
    let msg = '';
    let isMismatchError = false;
   switch(error.errorStatusId){
    case misMatchStatus.dobAndGenderMismatch:
      msg = ConstantData.genderAndDobMismatchText;
      isMismatchError = true;
    break; 
    case misMatchStatus.dobMismatch: 
    msg = ConstantData.dobMismatchText;
    isMismatchError = true;
    break;
    case misMatchStatus.genderMismatch: 
    msg =ConstantData.genderMismatchText; 
    isMismatchError = true;
    break;
    case misMatchStatus.minor:
      this.util.route('home');
      this.util.show(ConstantData.minorMismatchTitle,this.util.discardLoan.bind(this.util, this.util.route.bind(this.util, 'home')),()=>{},false,true,'',ConstantData.minorMismatchText1,ConstantData.minorMismatchText2,ConstantData.minorMismatchText3,ConstantData.minorBtnText,false,true,ConstantData.warnImage);
     return;
   }
   if(isMismatchError && panData){
  
    this.util.showToaster(msg, TosterMsgType.WARNING,ConstantData.popUpTimer * 1000, this.updateStudentDetails.bind(this,panData), false);
  }else{
    this.showLoader = false;
    this.isValidPan = false;
  }

     
}
updateStudentDetails(panData:any){
  const loanDetails = this.util.loanDetails;
  const body = {
    genderType: ConstantData.genderType.find((gender:any)=> gender.label?.toLowerCase() === panData.gender?.toLowerCase())?.value,
    candidateDOB: this.util.formatDate( panData.dob, ConstantData.candidateDobFormate),
    "candidateName": loanDetails.institutionInfo.candidateName,
    "repayer": loanDetails.institutionInfo.repayer,
    "status": loanDetails.institutionInfo.employmentStatus,
    "employerName": loanDetails.institutionInfo.employerName,
    "monthlyIncome": loanDetails.institutionInfo.monthlyIncome,
    // "attachmentId": loanDetails.hasMoratorium? loanDetails.loanAttachment.find((attach:any)=>attach.docType === "OFFER_LETTER")?.fileInfo?.fileId :'',
    "courseId": loanDetails.institutionInfo.courseId
  };
  this.util.loaderService.show();
  this.util.handleRequests('put', this.util.getUrl('institute_candidateInfo', [loanDetails.loanId]), body).then((res:any)=>{
    this.util.getLoandetails().then(()=>{
      
      this.util.loaderService.hide();
        this.panConfirmation(panData);
     }).catch(()=>{
       this.showLoader = false;
     });
   }).catch(()=>{
       this.showLoader = false;
     });
 }
  // submitPanDetail(){
  //   const loanData = this.util.loanDetails;
    
  //   if(loanData.isStudentMainApplicant && !loanData.isSponser){
  //     //if student is main applicant

  //     this.util.showToaster('Not Implemented yet', TosterMsgType.WARNING);
  //      // this.util.handleRequests('put',this.util.getUrl('pan_confirm',[this.util.getCache('userInfo').userInfo.inProgressLoanId,this.util.getCache('userInfo').userInfo.id])).
  //     // then(res=>{
  //    //   this.util.navigationHandler();
  //   // })
  //   }else{
  //     this.util.setCache('panNumber',this.formGroup.controls['panNumber'].value);
  //     this.util.setCache('kycTab','basic');
  //     this.util.route('basicDetails');
  //   }
    
  // }
}
